'use strict';

exports.__esModule = true;
exports.ProjectView = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _materialUi = require('material-ui');

var _Grid = require('@prisma-cms/front/lib/modules/ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Tasks = require('./Tasks');

var _Tasks2 = _interopRequireDefault(_Tasks);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {}
  };
};

var ProjectView = exports.ProjectView = (_temp = _class = function (_EditableView) {
  _inherits(ProjectView, _EditableView);

  function ProjectView() {
    _classCallCheck(this, ProjectView);

    return _possibleConstructorReturn(this, _EditableView.apply(this, arguments));
  } // static contextTypes = {
  //   ...EditableView.contextTypes,
  //   openLoginForm: PropTypes.func.isRequired,
  // };


  ProjectView.prototype.canEdit = function canEdit() {
    var currentUser = this.context.user;

    var _ref = currentUser || {},
        currentUserId = _ref.id,
        sudo = _ref.sudo;

    var _ref2 = this.getObjectWithMutations() || {},
        id = _ref2.id,
        CreatedBy = _ref2.CreatedBy;

    var _ref3 = CreatedBy || {},
        createdById = _ref3.id;

    return !id || createdById && createdById === currentUserId || sudo === true;
  };

  ProjectView.prototype.save = function save() {
    var _context = this.context,
        currentUser = _context.user,
        openLoginForm = _context.openLoginForm;

    if (!currentUser) {
      return openLoginForm();
    }

    return _EditableView.prototype.save.call(this);
  };

  ProjectView.prototype.getCacheKey = function getCacheKey() {
    var _ref4 = this.getObject() || {},
        id = _ref4.id;

    return 'project_' + (id || "new");
  };

  ProjectView.prototype.renderHeader = function renderHeader() {
    var classes = this.props.classes;
    var object = this.getObjectWithMutations();

    var _ref5 = object || {},
        projectId = _ref5.id,
        CreatedBy = _ref5.CreatedBy,
        createdAt = _ref5.createdAt,
        Tasks = _ref5.Tasks;

    var inEditMode = this.isInEditMode();
    var _context2 = this.context,
        UserLink = _context2.UserLink,
        ProjectLink = _context2.ProjectLink;
    return _react2.default.createElement('div', {
      className: classes.header
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      spacing: 16
    }, _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: true
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      alignItems: 'center'
    }, _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: inEditMode
    }, inEditMode ? this.getTextField({
      name: "name",
      fullWidth: true
    }) : projectId ? _react2.default.createElement(ProjectLink, {
      object: object
    }) : null), _react2.default.createElement(_Grid2.default, {
      item: true
    }, this.getButtons()), _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: !inEditMode
    }), _react2.default.createElement(_Grid2.default, {
      item: true
    }, CreatedBy ? _react2.default.createElement(UserLink, {
      user: CreatedBy
    }) : null)))));
  };

  ProjectView.prototype.renderTasks = function renderTasks() {
    var showDetails = this.props.showDetails;
    var project = this.getObjectWithMutations();

    if (!project) {
      return null;
    }

    var Link = this.context.Link;
    var projectId = project.id,
        Tasks = project.Tasks;
    return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_materialUi.Typography, {
      variant: 'subheading'
    }, "\u0417\u0430\u0434\u0430\u0447\u0438 \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 ", projectId ? _react2.default.createElement(Link, {
      to: '/tasks/create/' + projectId
    }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C") : null), Tasks && Tasks.length ? _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, _react2.default.createElement(_Tasks2.default, {
      project: project,
      tasks: Tasks,
      showDetails: showDetails
    })) : null);
  };

  ProjectView.prototype.renderDefaultView = function renderDefaultView() {
    var _props = this.props,
        classes = _props.classes,
        showDetails = _props.showDetails;
    var project = this.getObjectWithMutations();

    if (!project) {
      return null;
    }

    var projectId = project.id,
        content = project.content,
        Tasks = project.Tasks;
    var inEditMode = this.isInEditMode();
    var allow_edit = this.canEdit();
    var details = void 0;

    if (showDetails) {
      details = _react2.default.createElement(_react.Fragment, null, this.renderTasks());
    }

    return _react2.default.createElement(_Grid2.default, {
      container: true
    }, details);
  };

  ProjectView.prototype.renderEditableView = function renderEditableView() {
    return this.renderDefaultView();
  };

  ProjectView.prototype.renderResetButton = function renderResetButton() {
    var _ref6 = this.getObjectWithMutations() || {},
        id = _ref6.id;

    return id ? _EditableView.prototype.renderResetButton.call(this) : null;
  };

  ProjectView.prototype.render = function render() {
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, _EditableView.prototype.render.call(this));
  };

  return ProjectView;
}(_Editable2.default), _class.propTypes = _extends({}, _Editable2.default.propTypes, {
  classes: _propTypes2.default.object.isRequired,
  showDetails: _propTypes2.default.bool.isRequired
}), _class.defaultProps = _extends({}, _Editable2.default.defaultProps, {
  showDetails: false
}), _temp);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(ProjectView, props);
});